import React, { useState } from "react";
import UpTastingLogo from "../../../../assets/images/hcb_logo_light.png";
import styled from "@emotion/styled";
import Button from "../../../shared/Button";

const StartComponent = ({ config, canStart, start }) => {
    const Wrapper = {
        height: "100%",
        width: "100%",
        display: "flex",
        position: "relative",
        background: "black",
        justifyContent: "center",
        flexDirection: "column"
    };

    const Content = {
        width: "50%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
    };

    const LogoStyle = styled.img`
        max-width: 10vw;
        max-height: 10vh;
        margin: 4vh auto;
    `;

    const Text = styled.div`
        margin: 4vh auto;
        color: white;
        font-size: 2.5vh;
    `;

    return (
        <div style={Wrapper}>
            <LogoStyle src={config.logo || UpTastingLogo} />
            <div style={Content}>
                {canStart ? (
                    <>
                        <Text>{config?.survey?.name}</Text>
                        <Button value={"Start"} action={start} style={"width: fit-content; margin: 0 auto;"} />
                    </>
                ) : (
                    <Text>{config?.strings?.loading}</Text>
                )}
            </div>
        </div>
    );
};

export default StartComponent;
